import { IColunasSettingsUser } from "@app/shared/utils/validar_settings_user";

export const COLUNAS_DEFAULT_MODULE_PARCEIRO = [
  {
    module: 'PAR_FONECEDOR',
    colunas: [
      {
        field: 'codigo',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'parceiro.apelido_nome_fantasia',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.cpf_cnpj',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'PAR_ATENDENTE',
    colunas: [
      {
        field: 'codigo',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'parceiro.apelido_nome_fantasia',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.cpf_cnpj',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.user.name',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'PAR_PROFISSIONAL',
    colunas: [
      {
        field: 'codigo',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'parceiro.apelido_nome_fantasia',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.cpf_cnpj',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.user.name',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'PAR_PACIENTE',
    colunas: [
      {
        field: 'codigo',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'parceiro.apelido_nome_fantasia',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.cpf_cnpj',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.user.name',
        active: true,
        removable: true
      }
    ]
  }
] as IColunasSettingsUser[];
